import {
  Component,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { ServiceProviderService } from '../../../../Service/Service-providers/service-provider.service';
import { FormStateService } from '../form-state.service';
import { ToastService } from '../../../../Service/ToastService/toast.service';
import { CustomInputNumberTypeComponent } from '../../custom-input-number';
import { ReloadService } from '../../../../Service/Reload-service/reload.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-technician-info',
  templateUrl: './technician-info.component.html',
  styleUrls: ['./technician-info.component.scss'],
})
export class TechnicianInfoComponent implements OnInit {
  form = new FormGroup({});
  @Output() nextSection = new EventEmitter<void>();
  model: { [key: string]: any } = {};
  fields: FormlyFieldConfig[] = [];
  isFormPopulated = false;
  serviceProviderId: any; // New property to hold serviceProviderId
  isLoading!: boolean;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() updateServiceProviderList: EventEmitter<void> = new EventEmitter<void>();


  constructor(
    private api: ServiceProviderService,
    private formStateService: FormStateService,
    private toastService: ToastService,
    private formlyConfig: FormlyConfig,
    private reloadService: ReloadService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.loadTechnicians();
    this.initializeFormData();
    // Get the serviceProviderId and store it locally
    this.serviceProviderId = this.formStateService.getServiceProviderId();

    if (!this.formlyConfig.getType('input-number')) {
      this.formlyConfig.setType({
        name: 'input-number',
        component: CustomInputNumberTypeComponent,
      });
    }
  }

  ngOnDestroy() {
    this.saveFormData();
  }

  populateFormWithServiceProviderDetails(res: any) {
    if (!this.isFormPopulated) {
      this.model = {};

      res.serviceProviderTechnicians?.forEach((technician: any) => {
        this.model[technician.technicianId.toString()] = technician.noOfTechnician;
      });

      this.form.patchValue(this.model);
      this.isFormPopulated = true;
      this.formStateService.setFormData('Technician-info', this.model);
    }
  }

  loadTechnicians() {
    this.api.getTechnicianList('').subscribe(
      (response) => {
        this.fields = response.map((technician: any) => ({
          key: technician.technicianId.toString(),
          type: 'input-number',
          templateOptions: {
            label: technician.name,
            type: 'input-number',
            defaultValue: 0,
          },
        }));
        this.updateFormlyFields();
      },
      (error) => {
        console.error('Error fetching technicians', error);
      }
    );
  }

  resetForm() {
    this.form.reset();
    this.model = {};
  }

  initializeFormData() {
    const savedData = this.formStateService.getFormData('Technician-info');
    if (savedData) {
      this.model = savedData;
      this.isFormPopulated = true;
    }
  }

  updateFormlyFields() {
    this.fields.forEach((field) => {
      const key = field.key!.toString();
      field.defaultValue = this.model[key] || 0;
    });
  }

  get totalTechnicians(): number {
    let total = 0;
    for (const field of this.fields) {
      const key = field.key!.toString();
      if (this.model[key]) {
        total += +this.model[key];
      }
    }
    return total;
  }

  onSubmit() {
    console.log('Technician Model:', this.model);
    if (this.form.valid) {
      this.formStateService.setTechnicianCount(this.model);
      const combinedData = this.formStateService.getCombinedData();

      this.api.createServiceProvider(combinedData).subscribe({
        next: (res: any) => {
          console.log(res);
          this.reloadService.triggerReload()
          this.handleSuccess('Service provider added successfully')
        },
        error: (error) => {
          const message = error?.error?.message || error?.error || 'An unexpected error occurred.';
          this.toastService.showToast(message, 'error');
        }
      });

      console.log('Combined Data:', JSON.stringify(combinedData));
    }
  }
  handleSuccess(message: string): void {
    this.isLoading = false;
    this.toastService.showToast(message, 'success');
    setTimeout(() => {
      this.updateServiceProviderList.emit();
      this.close.emit();
    }, 500);
  }

  saveFormData() {
    const formData = { ...this.model };
    this.formStateService.setFormData('Technician-info', formData);
    console.log('Form data saved:', formData);
  }

  update() {
    if (this.form.valid) {
      this.formStateService.setTechnicianCount(this.model);

      // Get the combined data after setting the technician count
      const combinedData = this.formStateService.getCombinedData();
      console.log('Combined Data:', combinedData);
      this.api.updateServiceProviderInfo(this.serviceProviderId, combinedData).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.toastService.showToast('Service Provider updated successfully', 'success');
          this.close.emit();
          this.updateServiceProviderList.emit();
          this.router.navigate(['../'], { relativeTo: this.route });
        },
        error: (error) => {
          this.isLoading = false;
          const message = error?.error?.message || error?.error || 'An error occurred while updating.';
          this.toastService.showToast(message, 'error');
        }
      });

    }
  }

}

